import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { fromEvent } from 'rxjs';
import { FuseSplashScreenService } from '../../@fuse/services/splash-screen';

@Injectable({
    providedIn: 'root',
})
export class OfflineService {
    constructor(
        private splash: FuseSplashScreenService,
        @Inject(PLATFORM_ID) private platformId: object
    ) {
        // Only set up window event listeners in browser
        if (isPlatformBrowser(this.platformId)) {
            fromEvent(window, 'online').subscribe((event) => this.splash.hide());
            fromEvent(window, 'offline').subscribe((event) => this.splash.show());
        }
    }
}
